function obfuscate(value) {
  if (
    !this.context
    || !this.context.config
    || !this.context.config.obfuscate
  ) {
    return value;
  }

  const chars = [...value];
  const positions = [];
  const alphanumerics = [];

  chars.forEach((char, index) => {
    if (/[A-Za-z0-9]/.test(char)) {
      positions.push(index);
      alphanumerics.push(char);
    }
  });

  // Fisher–Yates shuffle
  for (let i = alphanumerics.length - 1; i > 0; i--) {
    const j = Math.floor(Math.random() * (i + 1));
    [alphanumerics[i], alphanumerics[j]] = [alphanumerics[j], alphanumerics[i]];
  }

  positions.forEach((pos, i) => {
    chars[pos] = alphanumerics[i];
  });

  return chars.join('');
}

module.exports = obfuscate;



// WEBPACK FOOTER //
// ./src/libs/twig/obfuscate/index.js